// Values shared by several keys, declared once so an alias cannot drift from what it mirrors.
const PRIMARY_BLUE = '#0072CE';
const SUCCESS_GREEN = '#4BA581';
const SURFACE_GREY = '#F7F8FA';
const INK = '#1D252D';
const INK_MUTED = '#5b6770';
const BORDER_GREY = '#EEF0F4';
const BORDER_NEUTRAL = '#D5D8DC';
const WHITE = '#FFFFFF';
const DEEP_PURPLE = '#9D26AD';

export default {
  // Brand and status
  '@primary-color': PRIMARY_BLUE,
  '@primary-color-dark': '#005090',
  '@primary-color-darker': '#003763',
  '@primary-color-extra-xx': '#F2F8FD',
  '@primary-color-disabled': '#73B1E4',
  '@primary-color-disabled-text': '#D5E8F7',
  '@error-color': '#C42137',
  '@error-color-light': '#F6D9DD',
  '@error-color-dark': '#AE1328',
  '@error-color-disabled': '#F17B7F',
  '@error-color-background': '#FEF2F2',
  '@warning-color': '#faad14',
  '@warning-color-light': '#DCB746',
  '@success-color': SUCCESS_GREEN,
  '@success-color-light': '#E4F7F1',
  '@success-color-dark': '#226E59',
  '@info-color': '#1699ef',

  // Text
  '@text-color': INK,
  '@text-color-secondary': INK_MUTED,
  '@text-color-disabled': 'rgba(0, 0, 0, 0.45)',
  '@label-color': INK,
  '@font-grey-light': '#a1a3a6',

  // Links
  '@link-color': PRIMARY_BLUE,
  '@link-hover-color': '#238fdb',
  '@link-active-color': '#0057a8',

  // Surfaces
  '@white': WHITE,
  '@white-accent': '#F8FAFB',
  '@body-bg': SURFACE_GREY,
  '@body-background': SURFACE_GREY,
  '@grey-background': '#FAFAFA',
  '@background-grey-color': '#e7e9ea',
  '@background-overlay': BORDER_GREY,
  '@item-hover-bg': '#E3F0FF',
  '@menu-item-active-bg': SURFACE_GREY,
  '@disabled-bg': '#EDEDED',
  '@notification-bg': '#EAF4FB',
  '@notification-bg-hover': '#D5E8F7',
  '@splash-bg': '#d0d1d2',
  '@video-bg': '#F1F6FF',

  // Borders
  '@border-color-base': '#E4E4E4',
  '@border-color-split': '#D9DCE1',
  '@border-color-grey': BORDER_GREY,
  '@border-light-grey': '#e8e8e8',
  '@input-border-color': '#BABCBFB2',

  // Component defaults
  '@btn-default-color': INK,
  '@btn-default-border': BORDER_NEUTRAL,
  '@switch-background': SURFACE_GREY,
  '@switch-button-active': WHITE,
  '@radio-button-color': INK_MUTED,

  // Key deposit
  '@key-deposit': '#3e54b1',
  '@key-retrieve': DEEP_PURPLE,

  // Check-in / check-out workflow
  '@checkIn-sent': '#F5D3BC',
  '@checkIn-completed': '#DD6B20',
  '@checkOut-sent': '#EBEDEF',
  '@checkOut-completed': '#39485C',
  '@checkOut-manually-completed': '#202631',
  '@homeCheckIn-completed': '#EBA679',
  '@homeCheckOut-completed': '#5F7998',

  // Neutral scale
  '@grey-light-elevated': '#E3E3E6',
  '@grey-light': '#AAAAAE',
  '@grey-base': '#6A6A6E',
  '@grey-dark': '#404040',
  '@grey-dark-elevated': '#000000',
  '@neutral-low': BORDER_NEUTRAL,
  '@grey-20': '#D9E1E8',

  // Hue-named, no semantic role
  '@bright-navy-blue': PRIMARY_BLUE,
  '@jungle-green': SUCCESS_GREEN,
  '@purple-munsell': DEEP_PURPLE,
  '@red-heart': '#eb2f96',
  '@gray-web': '#7f7979',
  '@yellow-light-tarnished': '#FFF2C9'
};
